import Vue from 'vue'
import App from './App.vue'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import http from './api/http.js'
import store from './store/index.js'
import VueCropper from 'vue-cropper' 
import './assets/css/common.less'
import { commonName } from './assets/css/common.less'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { staticPath} from  '@/utils/baseUrl.js'
import tagsList from '@/components/tags/tags.vue'
import Pagination from '@/components/pagination/pagination.vue'
import 'video.js/dist/video-js.css'
import dragVerify from 'vue-drag-verify2'
import VueClipBoard from 'vue-clipboard2'
import TestPhone from '@/components/testPhone/index'
import { selectLoadMore, tableLoadMore } from '@/utils/myDirective.js'

// 正式环境清除所有console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function () {};
  }
}

Vue.component('Pagination',Pagination) //分页挂载到全局
import JoinMarket from '@/pages/dy/marketing/joinMarketList.vue'
Vue.component('join-market',JoinMarket) //单选课程挂载到全局
import gettingList from '@/pages/gettingUserInformation/gettingList.vue'
Vue.component('gettingList',gettingList) //多选课程挂载到全局
Vue.prototype.staticPath = staticPath
Vue.prototype.commonName = commonName
if(process.env.VUE_APP_GRALIC === 'development' || process.env.VUE_APP_GRALIC === 'test') {
  Vue.prototype.fileUrl = 'https://video.doutuimao.net/'
  // Vue.config.silent = true
} else {
	Vue.prototype.fileUrl = 'https://doubaosrc.doutuimao.net/'
}
Vue.prototype.cancelRequestT = function (source) {
  if (typeof source === 'function') {
    source('终止请求')
  }
}
Vue.prototype.getBaseUrl = () => {
  let baseURL = ''
  if(process.env.VUE_APP_GRALIC === 'development') {
    baseURL = '/api'
  } else if(process.env.VUE_APP_GRALIC === 'test') {
    baseURL = 'http://wisdom.fat.doutuimao.net'
  } else {
    baseURL = 'http://wisdom.doutuimao.net'
  }
  return baseURL
}
Vue.use(selectLoadMore)
Vue.use(tableLoadMore)
Vue.component('tagsList', tagsList)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.use(dragVerify)
Vue.use(VueClipBoard)
Vue.use(TestPhone, {
  store
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
